import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras } from '@angular/router';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';

import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';

import { ShipmentVarietySizeFacade } from '../../../common/facade/ShipmentVarietySizeFacade';
import { ShipmentVarietySize } from '../../../common/model/ShipmentVarietySize';
import { CatalogDetFacade } from '../../../common/facade/CatalogDetFacade';
import { CatalogDet } from '../../../common/model/CatalogDet';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';

@Component({
  selector: 'app-inventory-entry',
  templateUrl: './inventory-entry.component.html',
  styleUrls: ['./inventory-entry.component.css']
})
export class InventoryEntryComponent implements OnInit {

  loading = false;
  messageLoader = '';
  // alert
  alerts = [];

  rows: ShipmentVarietySize[];
  catalogStatus: CatalogDet[];
  private _filteredData: ShipmentVarietySize[];

  deliveryCode = '';
  invoiceNumber = '';
  totalEntries = 0;
  inventoryEntries = 0;
  totalMissing = 0;

  titleDelivery = res.Delivery;
  lblMerchandiseTotalToEntryMayus = res.MerchandiseTotalToEntryMayus;
  lblMerchandiseEntryMayus = res.MerchandiseEntryMayus;
  lblDownload = res.Download;
  lblSearch = res.Search;
  lblDepartment = res.Department;
  lblGender = res.Gender;
  lblStyle = res.Style;
  lblVariety = res.Variety;
  lblSize = res.Size;
  lblUnits = res.Units;
  lblStatus = res.Status;
  lblDescription = res.Description;
  lblDifferences = res.MissingMerchandiseMayus;
  lblSent = res.AmountSent;
  lblReceived = res.AmountReceived;
  lblMissung = res.Differences;
  SubtitleDelivery = res.Invoice;
  public extras: NavigationExtras;
  public path = 'inventory/shipments';
  private _storeId = -1;
  private _startDate: string;
  private _endDate: string;
  private _organizationId = null;

  isSpanish = true;

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };

  constructor(
    private _facadeShipmentVarietySize: ShipmentVarietySizeFacade
    , private _facadeCatalogDet: CatalogDetFacade
    , private _activatedRoute: ActivatedRoute
    , private _excel: ExcelUtility
    , public strings: Strings
  ) { }

  ngOnInit() {
    this.loading = true;

    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    const id = this._activatedRoute.snapshot.paramMap.get('id');
    const statusMerchandiseIncome = 26;
    this.deliveryCode = id;

    let language = 0;
    if (!this.isSpanish) {
      language = 1;
    }

    // Obtener catalogos de Estatus de ingreso de mercancía
    this._facadeCatalogDet.Get(statusMerchandiseIncome, language).subscribe(resultCatalog => {
      if (resultCatalog.completed) {
        this.catalogStatus = resultCatalog.data;
        // Obtener listado de mercancía a ingresar
        this._activatedRoute.queryParams.subscribe(params => {
          this._storeId = Number(params['storeid']);
          this._startDate = params['startDate'];
          this._endDate = params['endDate'];
          this._organizationId = params['organizationid'];
          this.extras = {
              queryParams: {
                  'storeid': this._storeId
                  , 'startDate': this._startDate
                  , 'endDate': this._endDate
                  , 'organizationid': this._organizationId
              }
          };
        });
        
        this._facadeShipmentVarietySize.GetByDeliveryCode(id, this._organizationId).subscribe(result => {
          if (result.completed) {
            this.rows = result.data;
            this._filteredData = result.data;
          } else {
            this.addAlert('<strong>' + this.strings.GetText(res.AlertErrorGettingInformation) + '</strong>', 'danger');
          this.loading = false;
          }

          let totalEntriesAux = 0;
          let inventoryEntriesAux = 0;

          this.rows.forEach(r => {
            totalEntriesAux += r.totalQuantity;
            inventoryEntriesAux += r.receivedQuantity;

            if  (!isNullOrUndefined(r.invoiceNumberTitle)) {
              this.invoiceNumber = r.invoiceNumberTitle
            }

            const found = this.catalogStatus.find(element => element.catDetId == r.status);
            r.status = found.name;
          });

          this.totalEntries = totalEntriesAux;
          this.inventoryEntries = inventoryEntriesAux;
          this.totalMissing = totalEntriesAux - inventoryEntriesAux;
          this.loading = false;
        }, error => {
          this.addAlert('<strong>' + error + '</strong>', 'danger');
          this.loading = false;
        });

      } else {
        this.addAlert('<strong>' + this.strings.GetText(res.AlertErrorGettingCatalogs) + '</strong>', 'danger');
      this.loading = false;
      }
    }, error => {
      this.addAlert('<strong>' + error + '</strong>', 'danger');
      this.loading = false;
    });
  }

  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent) {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();

    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);

    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
          return true;
        }
      }
    });
  }

  downloadLayout() {
    if (this.rows.length > 0) {
        const data: any = [];
        this.rows.forEach(row => {
            const info = {
                [this.strings.GetText(res.Department)] : row.division,
                [this.strings.GetText(res.Gender)] : row.gender,
                [this.strings.GetText(res.Style)] : row.style,
                [this.strings.GetText(res.Variety)] :  row.variety,
                [this.strings.GetText(res.Size)] : row.sizeName,
                [this.strings.GetText(res.Units)] : row.totalQuantity,
                [this.strings.GetText(res.Status)] : row.status,
            };
            data.push(info);
        });
        this._excel.exportAsExcelFile(data, 'data');
    } else {
        this.addAlert(this.strings.GetText(res.AlertSelectActivityFirst), 'danger');
    }
  }

}
